import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import CustomDialog from "../common/tableComponent.js/dialog";
import {
  makeRequest,
  transactionRequest,
  updateTransactionRequest,
} from "../common/customServiceCall/serviceCall";
import { useSelector } from "react-redux";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { ProgressSpinner } from "primereact/progressspinner";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { format, set } from "date-fns";
import ReactTooltip from "react-tooltip";
import { withRouter } from "react-router-dom";
import CountryFlag from "react-country-flag";

const Transaction2 = (props) => {
  const userDetails = useSelector((state) => state.login.userDetails);

  const token = userDetails._id;

  const toast = useRef(null);

  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([] || null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showCancelTransactionModal, setShowCancelTransactionModal] =
    useState(false);

  const [showUpdateStatusModal, setShowUpdateStatusModal] = useState(false);
  const [showParkingModal, setShowParkingModal] = useState(false);
  const [dateRange, setDateRange] = useState(null);
  const [status, setStatus] = useState(null);
  const [country, setCountry] = useState(null);

  const [transId, setTransId] = useState("");
  const [sysTransId, setSysTransId] = useState("");
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [purpose, setPurpose] = useState("");
  const [retrievalId, setRetrievalId] = useState("");
  const [retrievalDate, setRetrievalDate] = useState("");

  const [datetime24h, setDateTime24h] = useState(null);
  const [selectedAddressRetry, setSelectedAddressRetry] = useState(null);
  const [showUpdateTransactionModal, setShowUpdateTransactionModal] =
    useState(false);
  const [selectedTransactionStatus, setSelectedTransactionStatus] =
    useState(null);
  const [addressRetry, setAddressRetry] = useState([
    { label: "Instant Credit VA Queue", value: "INSTANT_CREDIT_VA_QUEUE" },
    { label: "Transaction Status Check", value: "transaction-status-check" },
  ]);
  const [completionData, setCompletionData] = useState({
    transaction_pay_id: "",
    request_type: "",
    transaction_system_id: "",
  });

  const statusFilter = [
    { label: "All", value: "" },
    { label: "Pending", value: "0" },
    { label: "Success", value: "1" },
    { label: "Failed", value: "2" },
    { label: "Processing", value: "3" },
    { label: "Low_Bal", value: "4" },
    { label: "Re_Queued", value: "5" },
    { label: "Cancelled", value: "6" },
    { label: "Back_Off", value: "7" },
    { label: "Queued_Fs_Failed", value: "8" },
    { label: "Retrieved", value: "77" },
  ];

  const statusMap = {
    PENDING: { label: "Pending", color: "orange" },
    SUCCESSFUL: { label: "Success", color: "green" },
    FAILURE: { label: "Failed", color: "red" },
    PROCESSING: { label: "Processing", color: "blue" },
    LOW_BAL: { label: "Low_Bal", color: "purple" },
    RE_QUEUED: { label: "Re_Queued", color: "gray" },
    CANCELLED: { label: "Cancelled", color: "black" },
    BACK_OFF: { label: "Back_Off", color: "darkorange" },
    QUEUED_FS_FAILED: { label: "Queued_Fs_Failed", color: "pink" },
    RETRIEVED: { label: "Retrieved", color: "teal" },
  };

  const statusTemplate = (rowData) => {
    const status = statusMap[rowData.status] || {
      label: "Unknown",
      color: "gray",
    };

    return (
      <p
        className="p-tag"
        style={{
          backgroundColor: status.color,
          color: "white", // Text color to contrast with the background
          padding: "5px 8px",

          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        {status.label}
      </p>
    );
  };

  const countryBodyTemplate = (rowData) => {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <CountryFlag
          countryCode={rowData.recipientCountry}
          svg
          style={{ width: "25px", height: "15px", marginRight: "8px" }}
        />
        {rowData.recipientCountry}
      </div>
    );
  };

  const handleViewModalDisplay = async (rowData) => {
    setSelectedTransaction(rowData); // Set the selected provider data
    setShowViewModal(true); // Open the modal
  };

  const handleCancelTransactionDisplay = async (rowData) => {
    setSelectedTransaction(rowData); // Set the selected provider data
    setShowCancelTransactionModal(true); // Open the modal
  };

  const handleUpdateStatusDisplay = async (rowData) => {
    setSelectedTransaction(rowData); // Set the selected provider data
    setShowUpdateStatusModal(true); // Open the modal
  };

  const handleParkingDisplay = async (rowData) => {
    setSelectedTransaction(rowData); // Set the selected provider data
    setShowParkingModal(true); // Open the modal
  };

  const handleUpdateTransaction = async (rowData) => {
    setSelectedTransaction(rowData); // Set the selected provider data
    setShowUpdateTransactionModal(true); // Open the modal
  };

  const eventButtonHistory = (rowData) => {
    props.history.push(`/transactions-history/${rowData.transId}`);
  };

  const actions = (rowData) => (
    <>
      <Button
        label=""
        icon="pi pi-eye"
        className="p-button-success p-mr-2"
        onClick={() => handleViewModalDisplay(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="View Details"
        data-for="toolTip1"
        data-place="top"
      />
      <Button
        label=""
        icon="pi pi-file"
        className="p-button-warning p-mr-2"
        onClick={() => eventButtonHistory(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="Activity History"
        data-for="toolTip1"
        data-place="top"
      />
      {rowData.status === "SUCCESSFUL" && (
        <Button
          label=""
          icon="pi pi-pencil"
          className="p-button-success p-mr-2"
          onClick={() => handleUpdateStatusDisplay(rowData)}
          style={{ fontSize: "15px", padding: "7px" }}
          data-tip="Update Status"
          data-for="toolTip1"
          data-place="top"
        />
      )}
      {rowData.status === "PENDING" && (
        <Button
          label=""
          icon="pi pi-times"
          className="p-button-success p-mr-2"
          onClick={() => handleCancelTransactionDisplay(rowData)}
          style={{ fontSize: "15px", padding: "7px" }}
          data-tip="Cancel Transaction"
          data-for="toolTip1"
          data-place="top"
        />
      )}

      {rowData.status === "PENDING" ||
        rowData.status === "PROCESSING" ||
        (rowData.status === "RE_QUEUED" && (
          <Button
            label=""
            icon="pi pi-reply"
            className="p-button-success p-mr-2"
            onClick={() => handleParkingDisplay(rowData)}
            style={{ fontSize: "15px", padding: "7px" }}
            data-tip="Park Transaction"
            data-for="toolTip1"
            data-place="top"
          />
        ))}
      {(rowData.status === "BACK_OFF" ||
        rowData.status === "PROCESSING" ||
        rowData.status === "RE_QUEUED") && (
        <Button
          label=""
          icon="pi pi-refresh"
          className="p-mr-2"
          onClick={() => handleUpdateTransaction(rowData)}
          style={{ fontSize: "15px", padding: "7px" }}
          data-tip="Complete Transaction"
          data-for="toolTip1"
          data-place="top"
        />
      )}
      <ReactTooltip id="toolTip1" />
    </>
  );

  const fetchData = async () => {
    setLoading(true);

    const requestData = {
      status: status || "",
      startDate: dateRange?.[0]
        ? format(
            new Date(dateRange[0].setHours(0, 0, 0, 0)),
            "yyyy-MM-dd'T'HH:mm:ss"
          )
        : "",
      endDate: dateRange?.[1]
        ? format(
            new Date(dateRange[1].setHours(0, 0, 0, 0)),
            "yyyy-MM-dd'T'HH:mm:ss"
          )
        : "",
      transId: transId || "",
      sysTransId: sysTransId || "",
      size: "5000",
      page: "1",
      recipientCountry: country || "", // Include the `country` parameter
    };

    const filteredRequestData = Object.fromEntries(
      Object.entries(requestData).filter(([key, value]) => value !== "")
    );

    const queryString = new URLSearchParams(filteredRequestData).toString();

    try {
      const response = await transactionRequest(
        "get",
        `api/v1/transaction/filter?${queryString}`
      );

      if (response.code === "00") {
        setCustomers(response.data || []); // Set data or empty array
      } else {
        setCustomers([]); // No data, clear the table
        console.error("Failed to fetch data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [transId, sysTransId, status, dateRange]); // Re-fetch data when filters change

  const getSearchedData = () => {
    fetchData(); // Re-fetch the data with the updated filters
  };

  const handleCountryChange = (event) => {
    const selectedValue = event.value;
    setCountry(selectedValue); // Update the state
  };
  useEffect(() => {
    if (country !== null) {
      fetchData(); // Call API only after `country` is updated
    }
  }, [country]);

  const dateTemplate = (rowData) => {
    return <p>{format(new Date(rowData.createdAt), "yyyy-MM-dd HH:mm:ss")}</p>;
  };

  const cardStyle = { borderRadius: "40px" };
  const filterInputBoxStyle = { borderRadius: "4px", width: "100%" };
  const labelStyleLeft = { fontSize: "14px" };

  const labelStyleRight = {
    fontSize: "14px",
    float: "left",
    fontWeight: "500",
  };

  const floatLabel = {
    fontWeight: "500",
    color: "rgb(153, 153, 153)",
    fontSize: "12px",
  };

  const labelStyle = {
    paddingLeft: "10px",
    fontSize: "12px",
    color: "rgb(92, 74, 181)",
    fontWeight: "500",
  };
  const statusOptions = [
    { name: "Fail", value: "FAILED" },
    { name: "Fail No Retry", value: "FAILED_NO_RETRY" },
    { name: "Success", value: "SUCCESS" },
  ];

  const generateRandomId = (length = 16) => {
    return Array.from({ length }, () =>
      Math.floor(Math.random() * 36).toString(36)
    ).join("");
  };

  const requestId = generateRandomId();

  const handleCancelRequest = async () => {
    const formData = new FormData();
    formData.append("token", token);
    formData.append("request_id", requestId);
    formData.append("purpose", purpose);
    formData.append("trans_id", selectedTransaction.transId);

    console.log(formData, "cancellation-request");
    try {
      setLoading(true);
      const response = await makeRequest(
        "post",
        "add-cancellation-request",
        formData
      );
      console.log(response, "response cancellation");
      if (response.status === 200) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.msg,
        });
        setPurpose("");
        setShowCancelTransactionModal(false);
        await handleApproveRequest();
      } else {
        console.error("Failed to fetch data:");
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.msg,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };
  useEffect(() => {
    if (showUpdateTransactionModal && selectedTransaction) {
      setCompletionData({
        transaction_pay_id: selectedTransaction.payTransId || "",
        transaction_system_id: selectedTransaction.sysTransId || "",
      });
    }
  }, [
    showUpdateTransactionModal,
    selectedTransaction,
    selectedTransactionStatus,
  ]);

  const handleCompletionRequest = async () => {
    const formData = new FormData();
    formData.append("token", token);
    formData.append("request_type", completionData.request_type);
    formData.append(
      "transaction_system_id",
      completionData.transaction_system_id
    );
    formData.append("transaction_pay_id", completionData.transaction_pay_id);
    console.log(formData, "requestBody");

    try {
      setLoading(true);
      const response = await updateTransactionRequest(
        "post",
        "/completion/single/requests/create",
        formData
      );
      if (response.status === 200) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.msg,
        });
      } else {
        console.error("Failed to create completion request:");
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.msg,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
      setShowUpdateTransactionModal(false);
    }
  };

  const handleRetrievalRequest = async () => {
    const formData = new FormData();
    formData.append("token", token);
    formData.append("request_id", retrievalId);
    formData.append("purpose", purpose);
    formData.append("trans_id", selectedTransaction.transId);
    formData.append("retrieval_date", retrievalDate);

    try {
      setLoading(true);
      const response = await makeRequest(
        "post",
        "add-retrieval-request",
        formData
      );

      if (response.status === 200) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.msg,
        });

        setShowUpdateStatusModal(false);
        await handleRetrievalApproveRequest();
      } else {
        console.error("Failed to fetch data:");
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.msg,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const handleApproveRequest = async () => {
    const formData = new FormData();
    formData.append("token", token);
    formData.append("request_id", requestId);
    formData.append("status", "1");

    try {
      setLoading(true);
      const response = await makeRequest(
        "post",
        "cancellation-request-approval-status",
        formData
      );

      if (response.status === 200) {
        console.log("Success", response.msg);
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      } else {
        console.log("Failed to fetch data:", response.msg);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const handleRetrievalApproveRequest = async () => {
    const formData = new FormData();
    formData.append("token", token);
    formData.append("request_id", retrievalId);
    formData.append("status", "1");

    try {
      setLoading(true);
      const response = await makeRequest(
        "post",
        "retrieval-request-approval-status",
        formData
      );

      if (response.status === 200) {
        console.log("Success", response.msg);
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      } else {
        console.log("Failed to fetch data:", response.msg);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const handleParkingTransaction = async () => {
    // Validate required fields
    if (!selectedAddressRetry || !datetime24h) {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "Please select both address and retry time",
      });
      return;
    }

    const requestData = {
      addressToReprocess: selectedAddressRetry,
      institutionId: selectedTransaction.userId,
      nextRetry: datetime24h.toISOString(),
      originatingService: "MANUAL",
      transactionSystemId: selectedTransaction.transId,
    };

    try {
      setLoading(true);

      // Make sure your base URL is correct
      const response = await transactionRequest(
        "post",
        "/parking/transaction", // Double-check this endpoint
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.code === "00") {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.msg || "Transaction parked successfully",
        });
        setShowParkingModal(false);
        fetchData();
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.msg || "Failed to park transaction",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail:
          error.response?.data?.msg ||
          "An error occurred while processing your request",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <section className="p-my-4 p-md-12 p-xl-12" style={{ padding: "0px 10%" }}>
      <Toast ref={toast} />

      <div className="p-grid p-fluid p-mb-4">
        <div
          className="p-col-12 p-sm-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
          style={{ textAlign: "center" }}
        >
          <span className="p-tag custom-heading">Transaction</span>
        </div>
      </div>

      <div className="card" style={{ paddingTop: "0px" }}>
        <div
          className="p-grid p-align-center p-justify-center p-fluid"
          style={{ paddingTop: "10px" }}
        >
          {/* Date Range Picker */}
          <div className=" p-col-12 p-md-3">
            <label style={floatLabel}>DATE RANGE</label>
            <span className="p-float-label">
              <Calendar
                value={dateRange}
                onChange={(e) => setDateRange(e.value)} // Set date range
                selectionMode="range"
                readOnlyInput
                showIcon
                placeholder="Select Date Range"
              />
            </span>
          </div>

          {/* Country */}
          <div className=" p-col-12 p-md-2">
            <label style={floatLabel}>COUNTRY</label>
            <span className="p-float-label">
              <Dropdown
                style={filterInputBoxStyle}
                id="dropdown1"
                options={userDetails.allCountries.map((item) => ({
                  label: item.label,
                  value: item.value,
                }))} // Populate dropdown from userDetails
                value={country}
                onChange={handleCountryChange}
                autoWidth={false}
                placeholder="Select a country"
              />
            </span>
          </div>

          {/* Status Dropdown */}
          <div className=" p-col-12 p-md-2 ">
            <label style={floatLabel}>STATUS</label>
            <span className="p-float-label">
              <Dropdown
                value={status}
                options={statusFilter}
                onChange={(e) => setStatus(e.value)}
                placeholder="Select Status"
              />
            </span>
          </div>

          {/* Search Input */}
          <div className=" p-col-12 p-md-2">
            <label style={floatLabel}>TRANSACTION ID</label>
            <div className="p-inputgroup">
              <InputText
                value={transId}
                onChange={(e) => setTransId(e.target.value)}
                placeholder="Enter transId"
              />
            </div>
          </div>

          <div className=" p-col-12 p-md-2">
            <label style={floatLabel}>SYSTEM TRANSACTION ID</label>
            <div className="p-inputgroup">
              <InputText
                value={sysTransId}
                onChange={(e) => setSysTransId(e.target.value)}
                placeholder="Enter sysTransId"
              />
            </div>
          </div>
          <div className=" p-col-12 p-md-1">
            <Button
              onClick={getSearchedData}
              icon="pi pi-search"
              className="p-button-info"
              style={{ marginTop: "20px" }}
            />
          </div>
        </div>
      </div>
      <div className="card">
        {loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <ProgressSpinner
              style={{
                display: userDetails.showLoader,
                width: "40px",
                height: "40px",
                position: "fixed",
                top: "50%",
                left: "50%",
                bottom: "50%",
                right: "50%",
                zIndex: "1111111111",
              }}
              strokeWidth="3"
              animationDuration=".5s"
            />
          </div>
        ) : (
          <DataTable
            value={customers}
            paginator
            rows={5}
            rowsPerPageOptions={[5, 10, 25, 50]}
            tableStyle={{ minWidth: "60rem" }}
            className="p-datatable-responsive-demo"
          >
            <Column
              field="transId"
              header="Transaction Id"
              style={{ width: "40%", fontSize: "13px" }}
            ></Column>
            <Column
              field="sysTransId"
              header="System Transaction Id"
              style={{ width: "35%", fontSize: "13px" }}
            ></Column>

            <Column
              field="transAmount"
              header="Amount"
              style={{ width: "25%", fontSize: "13px" }}
            ></Column>
            <Column
              field="charges"
              header="Charges"
              style={{ width: "25%", fontSize: "13px" }}
            ></Column>
            <Column
              field="recipientCountry"
              header="Country"
              body={countryBodyTemplate}
              style={{ width: "25%", fontSize: "13px" }}
            ></Column>
            <Column
              field="recipientAccountNo"
              header="Destination"
              style={{ width: "25%", fontSize: "13px" }}
            ></Column>
            <Column
              field="status"
              header="Status"
              style={{ width: "30%", fontSize: "13px" }}
              body={statusTemplate}
            ></Column>
            <Column
              field="createdAt"
              header="Created At"
              style={{ width: "25%", fontSize: "13px" }}
              body={dateTemplate}
            ></Column>
            <Column
              header="Actions"
              style={{ width: "45%", fontSize: "13px" }}
              body={actions}
            ></Column>
          </DataTable>
        )}
      </div>
      <>
        <CustomDialog
          visible={showViewModal}
          header="View Transaction Modal"
          onClose={() => setShowViewModal(false)}
        >
          {selectedTransaction && (
            <div
              className="p-grid p-fluid transaction"
              style={{ height: "60vh", overflowY: "scroll" }}
            >
              <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
                <div style={cardStyle}>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Id</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.id || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Transaction Id</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.transId || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>
                        Transaction Reference Id
                      </label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.transReferenceId || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Vaid</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.vaId || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>User Id</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.userId || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Phone</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.phone || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>
                        Recipient Account Number
                      </label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.recipientAccountNo || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}> Recipient Bank Name</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.recipientBankName || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Reference Id</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.refId || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Recipient Ifsc</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.recipientIfsc || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Exchange Rate</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.exchangeRate || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Recipient Name</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.recipientName || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Recipient Country</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.recipientCountry || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Recipient Currency</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.recipientCurrency || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Sender Country</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.senderCountry || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Sender Currency</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.senderCurrency || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Sender Name</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.senderName || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Destination House</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.destinationHouse || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Billing Type</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.billingType || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Charges</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.charges || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Transaction Amount</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.transAmount || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Trans Description</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.transDesc || "N/A"}
                      </label>
                    </div>
                  </div>{" "}
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Created At</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {format(
                          new Date(selectedTransaction.createdAt),
                          "yyyy-MM-dd HH:mm:ss"
                        )}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Modified At</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {format(
                          new Date(selectedTransaction.modifiedAt),
                          "yyyy-MM-dd HH:mm:ss"
                        )}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Status</label>
                    </div>

                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.status}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Send Mode</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.sendMode || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>
                        Payment Transaction Id
                      </label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.payTransId || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Payment Method</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.payMethod || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Remittance Id</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.remitterId || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Reason</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.reason || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Result Code</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.resultCode || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Channel</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.channel || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Transaction Status</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.transStatus || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Retry Status</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.retryStatus || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Retryable</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.retryable || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Retry Count</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.retryCount || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Retry Max</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.retryMax || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Retry Minute</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.retryMinute || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Next Retry At</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.nextRetryAt || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Transaction Mode</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.transMode || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>
                        Recipient Bank Short Name
                      </label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.recipientBankShortName || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Sender Description</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.senderDesc || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>
                        System Transaction Id
                      </label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.sysTransId || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Job Status</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.jobStatus || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Attempt Id</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedTransaction.attemptId || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Attempt At</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {format(
                          new Date(selectedTransaction.attemptAt),
                          "yyyy-MM-dd HH:mm:ss"
                        )}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </CustomDialog>
        <CustomDialog
          visible={showCancelTransactionModal}
          header="Cancel Transaction Modal"
          onClose={() => setShowCancelTransactionModal(false)}
        >
          <div className="p-col-12 p-mt-3">
            <span className="p-float-label">
              <InputTextarea
                value={purpose}
                onChange={(e) => setPurpose(e.target.value)}
                rows={3}
                style={{ width: "100%" }}
              />
              <label style={labelStyle}>Purpose</label>
            </span>
          </div>
          <div
            className="p-col-12 p-md-12 p-lg-12 p-xl-12"
            style={{ textAlign: "center" }}
          >
            <Button
              onClick={handleCancelRequest}
              label="Submit"
              className="p-button-info p-mx-auto"
              type="submit"
              style={{ width: "50%" }}
            />
          </div>
        </CustomDialog>
        <CustomDialog
          visible={showUpdateTransactionModal}
          header="Transaction Completion Modal"
          onClose={() => setShowUpdateTransactionModal(false)}
        >
          {selectedTransaction && (
            <>
              <div className="p-col-12 p-mt-2">
                <label style={labelStyle}>Transaction ID</label>

                <InputText
                  type="text"
                  value={selectedTransaction.transId}
                  disabled
                  style={{ width: "100%" }}
                />
              </div>
              <div className="p-col-12 p-mt-2">
                <label style={labelStyle}>System ID</label>

                <InputText
                  type="text"
                  style={{ width: "100%" }}
                  value={selectedTransaction.sysTransId}
                  disabled
                />
              </div>
              <div className="p-col-12 p-mt-2">
                <label style={labelStyle}>Select completion status:</label>

                <Dropdown
                  value={completionData.request_type}
                  onChange={(e) =>
                    setCompletionData((prev) => ({
                      ...prev,
                      request_type: e.value,
                    }))
                  }
                  options={statusOptions}
                  optionLabel="name"
                  placeholder="Select Status"
                  style={{ width: "100%" }}
                />
              </div>
            </>
          )}
          <div
            className="p-col-12 p-md-12 p-lg-12 p-xl-12"
            style={{ textAlign: "center" }}
          >
            <Button
              onClick={handleCompletionRequest}
              label="Submit"
              className="p-button-info p-mx-auto"
              type="submit"
              style={{ width: "50%" }}
            />
          </div>
        </CustomDialog>
        <CustomDialog
          visible={showUpdateStatusModal}
          header="Update Status Modal"
          onClose={() => setShowUpdateStatusModal(false)}
        >
          <div className="p-grid p-fluid" style={{ marginTop: "1em" }}>
            <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-mt-3">
                  <span className="p-float-label">
                    <InputText
                      value={retrievalId}
                      onChange={(e) => setRetrievalId(e.target.value)}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Telco Retrieval Id</label>
                  </span>
                </div>
                <div className="p-col-12 p-mt-3 z-5" style={{ zIndex: "100" }}>
                  <span className="p-float-label">
                    <Calendar
                      value={retrievalDate}
                      onChange={(e) => setRetrievalDate(e.target.value)}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Date of Retrieval</label>
                  </span>
                </div>
                <div className="p-col-12 p-mt-3">
                  <span className="p-float-label">
                    <InputTextarea
                      value={purpose}
                      onChange={(e) => setPurpose(e.target.value)}
                      rows={3}
                      style={{ width: "100%" }}
                    />
                    <label style={labelStyle}>Purpose</label>
                  </span>
                </div>
                <div
                  className="p-col-12 p-md-12 p-lg-12 p-xl-12"
                  style={{ textAlign: "center" }}
                >
                  <Button
                    onClick={handleRetrievalRequest}
                    label="Submit"
                    className="p-button-info p-mx-auto"
                    type="submit"
                    style={{ width: "50%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </CustomDialog>
        <CustomDialog
          visible={showParkingModal}
          header="Park Modal"
          onClose={() => setShowParkingModal(false)}
        >
          <div className="p-grid p-fluid" style={{ marginTop: "1em" }}>
            <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
              <div className="p-grid p-fluid">
                <div className="p-col-12 p-mt-3">
                  <span className="p-float-label">
                    <Dropdown
                      value={selectedAddressRetry}
                      onChange={(e) => setSelectedAddressRetry(e.value)}
                      options={addressRetry}
                      className="w-full md:w-14rem"
                    />
                    <label style={labelStyle}>Address To Reprocess</label>
                  </span>
                </div>
                <div className="p-col-12 p-mt-3 z-5" style={{ zIndex: "100" }}>
                  <span className="p-float-label">
                    <Calendar
                      value={datetime24h}
                      onChange={(e) => setDateTime24h(e.value)}
                      showTime
                      hourFormat="24"
                    />
                    <label style={labelStyle}>Next Retry</label>
                  </span>
                </div>

                <div
                  className="p-col-12 p-md-12 p-lg-12 p-xl-12"
                  style={{ textAlign: "center" }}
                >
                  <Button
                    onClick={handleParkingTransaction}
                    label="Submit"
                    className="p-button-info p-mx-auto"
                    type="submit"
                    style={{ width: "50%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </CustomDialog>
      </>
    </section>
  );
};

export default withRouter(Transaction2);
